import React from 'react';
import { CalendarCheckIcon, RepeatIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { solutionStats } from '../../data/site';
const yearOptions = [{
  icon: CalendarCheckIcon,
  title: 'Across the school year',
  text: 'Teach one class a month and flag football is covered from the first term to the last.'
}, {
  icon: RepeatIcon,
  title: 'Or as a full unit',
  text: 'Run them back to back in six weeks at two a week, or twelve weeks at one a week.'
}];
export function Solution() {
  return <section aria-labelledby="solution-title" className="border-t border-line bg-mint py-20 text-ink lg:py-24" data-id="element-568" data-mp="ix3q3v4e6ypl">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-569" data-mp="e0d9n6ooe13n">
        <SectionHeading id="solution-title" eyebrow="The solution" lead="Your whole year of flag football," highlight="already solved" intro="A complete beginner flag football program for PE teachers working with students aged 10–14. Every class shows what to set up, what to say and what to look for — so you can walk in and teach, all year long." data-id="element-570" data-mp="ryk0w3z4d2uc" />

        <ul className="mt-12 grid grid-cols-2 overflow-hidden rounded-xl border border-line lg:grid-cols-4" data-id="element-571" data-mp="24ulp8fm3o7jx">
          {solutionStats.map((stat, index) => <li key={stat.label} className={`bg-paperwhite px-3 py-7 text-center ${index % 2 === 1 ? 'border-l border-line' : ''} ${index > 1 ? 'border-t border-line lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-572" data-mp="29s52pdaz4gat" data-mpi={index}>
              <span className="block font-display text-[48px] font-bold uppercase leading-none text-gold-dark sm:text-[60px]" data-id="element-573" data-mp="2nnpjo3756ofl">
                {stat.value}
              </span>
              <span className="mt-2 block text-[12px] font-bold uppercase tracking-[0.14em] text-body sm:text-[13px]" data-id="element-574" data-mp="2xldfyxkec3zv">
                {stat.label}
              </span>
            </li>)}
        </ul>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-575" data-mp="2cv13wlc6f3io">
          {yearOptions.map(option => <li key={option.title} className="flex gap-4 rounded-xl border border-line bg-paperwhite p-6 sm:p-7" data-id="element-576" data-mp="27ttyuu1f4ifp">
              <span aria-hidden="true" className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-gold" data-id="element-577" data-mp="2hu4c2engdpuv">
                <option.icon className="h-6 w-6" strokeWidth={2.25} data-id="element-578" data-mp="2vk7ueuj7ozf1" />
              </span>
              <div data-id="element-579" data-mp="2qmxswgijsxau">
                <h3 className="font-display text-[26px] font-bold uppercase leading-tight" data-id="element-580" data-mp="2qld1v0vfzwhq">{option.title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-body" data-id="element-581" data-mp="35inkcu6i62my">{option.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-582" data-mp="1b4w0z2ydg4eb">
          <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-583" data-mp="1b5xmy2gxebat">
            See what’s included
          </CtaButton>
        </div>
      </div>
    </section>;
}